import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import Landing from "@/pages/Landing";
import PubWelcome from "@/pages/PubWelcome";
import MainPage from "@/pages/MainPage";
import DJDashboard from "@/pages/DJDashboard";
import Admin from "@/pages/Admin";
import Owner from "@/pages/Owner";
import "@/App.css";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/pub/:slug" element={<PubWelcome />} />
          <Route path="/pub/:slug/home" element={<MainPage />} />
          <Route path="/dj" element={<DJDashboard />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/owner" element={<Owner />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="dark" position="top-center" richColors closeButton />
    </AuthProvider>
  );
}

export default App;
